import {createAsyncThunk, createSlice} from '@reduxjs/toolkit';
import api_comm from '../../common/lib';

export const getTransactionTypes = createAsyncThunk(
    'transaction/Types',
    async () => {
        try {
            let TransactionTypes = await api_comm(
                'get',
                '/finances/api/v2/transaction_types',

                {}
            );
            return TransactionTypes.data.data;
        } catch (e) {
            throw new Error(e);
        }
    }
);

const initialState = {
    TransactionTypes: [],
    loading: true,
};

export const TransactionTypeSlice = createSlice({
    name: 'TransactionTypes',
    initialState,
    reducers: {
        setTransactionTypes: (state, action) => {
            state.TransactionTypes = action.payload;
        },
    },
    extraReducers: {
        [getTransactionTypes.pending]: (state, action) => {
            state.loading = true;
        },
        [getTransactionTypes.fulfilled]: (state, action) => {
            state.TransactionTypes = action.payload;
            state.loading = false;
        },
        [getTransactionTypes.rejected]: (state, action) => {
            state.TransactionTypes = action.payload;
            state.loading = false;
        },
    },
});

export const {setNavLinks} = TransactionTypeSlice.actions;

export default TransactionTypeSlice.reducer;
